import { Box, Grid, Stack } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState, FC } from 'react';
import { IJob } from 'wisestep-api';
import { WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { removeCachedJob } from '../../../utils/cacheService';
import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';
import ViewDetailsDrawer from '../../jobs/listing/components/viewDetails/ViewDetailsDrawer';
import { useJobScreenContext } from '../context/JobScreenContext';
import conversationWidgetStore from '../store/conversationWidgetStore';

interface IWidgetJobManagement {
  selectedJob?: IJob | null;
  ss: number;
  hideRemove?: boolean;
  hideIfNoJob?: boolean;
  jobFetchFailure?: boolean;
  isFromMapAsLead?: boolean;
  setRemoveForMap?: () => void;
}

const WidgetJobManagement: FC<IWidgetJobManagement> = ({
  selectedJob,
  ss,
  hideRemove = false,
  hideIfNoJob = false,
  jobFetchFailure = false,
  isFromMapAsLead = false,
  setRemoveForMap,
}) => {
  const updateSelectedJob = conversationWidgetStore((state) => state.updateSelectedJob);
  const setChangeJob = useConversationWidgetStore((state) => state.setChangeJob);
  const jobScreen = useJobScreenContext();
  const [openViewDetails, setOpenViewDetails] = useState<boolean>(false);
  const [selectTab, setSelectTab] = useState<string>('JD');
  const removeJob = () => {
    setRemoveForMap && setRemoveForMap();
    removeCachedJob();
    updateSelectedJob(null);
    jobScreen.setShowJobScreen && jobScreen.setShowJobScreen({ showJobScreen: false });
  };

  const closeViewDetails = () => setOpenViewDetails(false);

  const openJobScreen = () => {
    setChangeJob(true);
    jobScreen.setShowJobScreen && jobScreen.setShowJobScreen({ showJobScreen: true });
  };

  return (
    <>
      <Grid item xs={ss} container rowGap={0.5}>
        {!jobFetchFailure && (
          <>
            {!isEmpty(selectedJob) && (
              <Box mt={0.5}>
                <WsTypography variant={WsTypoVariants.BODY1} bold={true}>
                  {`${selectedJob?.title} ( ${selectedJob?.jobCode} )`}
                </WsTypography>
              </Box>
            )}

            <Stack direction="row" display="flex" spacing={1} mt={0.7} ml={0.5}>
              {(!hideIfNoJob || selectedJob) && (
                <WsTypography
                  className="change-job"
                  variant={WsTypoVariants.BODY2}
                  cursor="pointer"
                  color={WsTypoColors.PRIMARY}
                  onClick={() => (isFromMapAsLead ? removeJob() : openJobScreen())}
                >
                  {!isEmpty(selectedJob) ? 'Change Job' : 'Select Job'}
                </WsTypography>
              )}
              {!isEmpty(selectedJob) && !hideRemove && (
                <WsTypography
                  variant={WsTypoVariants.BODY2}
                  cursor="pointer"
                  color={WsTypoColors.ERROR}
                  onClick={removeJob}
                >
                  Remove job
                </WsTypography>
              )}
              {!isEmpty(selectedJob) && !hideRemove && (
                <WsTypography
                  className="change-job"
                  variant={WsTypoVariants.BODY2}
                  cursor="pointer"
                  color={WsTypoColors.PRIMARY}
                  onClick={() => {
                    setSelectTab('JD');
                    setOpenViewDetails(true);
                  }}
                >
                  JD
                </WsTypography>
              )}
              {!isEmpty(selectedJob) && !hideRemove && (
                <WsTypography
                  className="change-job"
                  variant={WsTypoVariants.BODY2}
                  cursor="pointer"
                  color={WsTypoColors.PRIMARY}
                  onClick={() => {
                    setSelectTab('QUESTIONS');
                    setOpenViewDetails(true);
                  }}
                >
                  Questions
                </WsTypography>
              )}
            </Stack>
          </>
        )}
      </Grid>
      {openViewDetails && selectedJob && (
        <ViewDetailsDrawer
          job={selectedJob}
          selectTab={selectTab == 'JD' ? 0 : 1}
          open={openViewDetails}
          closeDetails={closeViewDetails}
        />
      )}
    </>
  );
};

export default WidgetJobManagement;
